var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7522_6824)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 16,
    fill: "#F0F2FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2575 15.5C21.8786 15.5 21.5065 15.6014 21.1799 15.7935C20.8533 15.9857 20.584 16.2617 20.4 16.593L19.757 17.75H17.875C17.1125 17.75 16.3812 18.0529 15.8421 18.5921C15.3029 19.1312 15 19.8625 15 20.625V29.125C15 29.8875 15.3029 30.6188 15.8421 31.1579C16.3812 31.6971 17.1125 32 17.875 32H23.498C23.33 31.5972 23.2034 31.1784 23.12 30.75H17.875C17.444 30.75 17.0307 30.5788 16.726 30.274C16.4212 29.9693 16.25 29.556 16.25 29.125V20.625C16.25 20.194 16.4212 19.7807 16.726 19.476C17.0307 19.1712 17.444 19 17.875 19H20.4925L21.4925 17.2C21.5683 17.0636 21.6792 16.9499 21.8137 16.8708C21.9482 16.7917 22.1014 16.75 22.2575 16.75H25.7425C25.8986 16.75 26.0518 16.7917 26.1863 16.8708C26.3208 16.9499 26.4317 17.0636 26.5075 17.2L27.5075 19H30.125C30.556 19 30.9693 19.1712 31.274 19.476C31.5788 19.7807 31.75 20.194 31.75 20.625V23.4C32.191 23.5625 32.61 23.772 33 24.022V20.625C33 19.8625 32.6971 19.1312 32.1579 18.5921C31.6188 18.0529 30.8875 17.75 30.125 17.75H28.243L27.6 16.593C27.416 16.2617 27.1467 15.9857 26.8201 15.7935C26.4935 15.6014 26.1214 15.5 25.7425 15.5H22.2575ZM24 20.5C24.8381 20.5 25.6551 20.7631 26.3356 21.2523C27.0162 21.7415 27.5259 22.4321 27.793 23.2265C27.3855 23.337 26.994 23.4865 26.623 23.67C26.477 23.2093 26.2121 22.7953 25.8551 22.4696C25.4981 22.1438 25.0616 21.9179 24.5895 21.8146C24.1174 21.7113 23.6264 21.7342 23.166 21.8811C22.7056 22.0279 22.292 22.2935 21.9669 22.6511C21.6418 23.0086 21.4166 23.4455 21.3141 23.9178C21.2116 24.3901 21.2354 24.881 21.3831 25.3412C21.5307 25.8013 21.797 26.2145 22.1551 26.539C22.5132 26.8634 22.9506 27.0878 23.423 27.1895C23.276 27.5755 23.1645 27.9795 23.093 28.397C22.1356 28.1754 21.2932 27.6092 20.7266 26.8062C20.1601 26.0033 19.9089 25.0199 20.021 24.0436C20.1331 23.0673 20.6007 22.1664 21.3346 21.5129C22.0685 20.8593 23.0173 20.4987 24 20.5ZM35 29.5C35 32.5375 32.5375 35 29.5 35C26.4625 35 24 32.5375 24 29.5C24 26.4625 26.4625 24 29.5 24C32.5375 24 35 26.4625 35 29.5ZM30 26.5C30 26.3674 29.9473 26.2402 29.8536 26.1464C29.7598 26.0527 29.6326 26 29.5 26C29.3674 26 29.2402 26.0527 29.1464 26.1464C29.0527 26.2402 29 26.3674 29 26.5V29H26.5C26.3674 29 26.2402 29.0527 26.1464 29.1464C26.0527 29.2402 26 29.3674 26 29.5C26 29.6326 26.0527 29.7598 26.1464 29.8536C26.2402 29.9473 26.3674 30 26.5 30H29V32.5C29 32.6326 29.0527 32.7598 29.1464 32.8536C29.2402 32.9473 29.3674 33 29.5 33C29.6326 33 29.7598 32.9473 29.8536 32.8536C29.9473 32.7598 30 32.6326 30 32.5V30H32.5C32.6326 30 32.7598 29.9473 32.8536 29.8536C32.9473 29.7598 33 29.6326 33 29.5C33 29.3674 32.9473 29.2402 32.8536 29.1464C32.7598 29.0527 32.6326 29 32.5 29H30V26.5Z",
    fill: "#6579F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7522_6824",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7522_6824"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7522_6824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7522_6824",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/cameraPlus.0e9955c7027680889567fb032631bb78.svg";
export { ForwardRef as ReactComponent };